export default __webpack_public_path__ + "bcf93df12dec10b5db7fb48b49485253.png";